export default "__VITE_ASSET__BckjKJXv__"